module.exports = __webpack_public_path__ + "static/media/Relative-Faux-Web.bd17fe39.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Faux-Web.eot
// module id = 735
// module chunks = 0